import { Card, DateInput, Input, Select } from "components"
import { useProductCategory } from "pages/Inventori/Register/utils"
import debounce from "lodash/debounce"
import moment from "moment"
import { useMemo, type Dispatch, type SetStateAction } from "react"
import { APPROVAL_OPTIONS, useLocation } from "utils"
import type { ItemBuildReportFilter } from "../types/itemBuildReport"

type FilterProps = {
  filter: ItemBuildReportFilter
  setFilter: Dispatch<SetStateAction<ItemBuildReportFilter>>
}

export function Filter({ filter, setFilter }: FilterProps) {
  const { data: locationOptions, isLoading: isLoadingLocation } = useLocation()
  const { dataCategory, isLoadingCategory } = useProductCategory()

  const onSearchDebounce = useMemo(
    () =>
      debounce((value: string) => {
        setFilter((prev) => ({ ...prev, keyword: value }))
      }, 400),
    [setFilter]
  )

  const locationSelectOptions = useMemo(
    () => [{ label: "All", value: "0" }, ...locationOptions],
    [locationOptions]
  )

  const categorySelectOptions = useMemo(
    () => [{ label: "All", value: "0" }, ...dataCategory],
    [dataCategory]
  )

  const approvalSelectOptions = useMemo(
    () => [{ label: "All", value: "0" }, ...APPROVAL_OPTIONS],
    []
  )

  return (
    <Card>
      <Card.Body>
        <section className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div className="flex flex-wrap items-end gap-3">
            <DateInput
              label="START DATE"
              wrapperClassName="w-full sm:w-[180px]"
              selected={
                filter.start_date ? moment(filter.start_date).toDate() : null
              }
              onChange={(date) =>
                setFilter((prev) => ({
                  ...prev,
                  start_date: date ? moment(date).format("YYYY-MM-DD") : "",
                }))
              }
            />
            <DateInput
              label="END DATE"
              wrapperClassName="w-full sm:w-[180px]"
              selected={filter.end_date ? moment(filter.end_date).toDate() : null}
              onChange={(date) =>
                setFilter((prev) => ({
                  ...prev,
                  end_date: date ? moment(date).format("YYYY-MM-DD") : "",
                }))
              }
            />
            <Select
              label="CATEGORY"
              controlClass="w-full sm:w-[180px]"
              width
              isLoading={isLoadingCategory}
              options={categorySelectOptions}
              value={categorySelectOptions.find(
                (item) => item.value === filter.category_id
              )}
              onChange={(option) => {
                if (option) {
                  setFilter((prev) => ({ ...prev, category_id: option.value }))
                }
              }}
            />
            <Select
              label="LOCATION"
              controlClass="w-full sm:w-[180px]"
              width
              isLoading={isLoadingLocation}
              options={locationSelectOptions}
              value={locationSelectOptions.find(
                (item) => item.value === filter.location_id
              )}
              onChange={(option) => {
                if (option) {
                  setFilter((prev) => ({ ...prev, location_id: option.value }))
                }
              }}
            />
            <Select
              label="APPROVED"
              controlClass="w-full sm:w-[180px]"
              width
              options={approvalSelectOptions}
              value={approvalSelectOptions.find(
                (item) => item.value === filter.approve_status
              )}
              onChange={(option) => {
                if (option) {
                  setFilter((prev) => ({ ...prev, approve_status: option.value }))
                }
              }}
            />
          </div>
          <Input
            label="SEARCH DATA"
            className="w-full lg:w-[300px]"
            placeholder="Search data..."
            defaultValue={filter.keyword}
            onChange={(e) => onSearchDebounce(e.target.value)}
          />
        </section>
      </Card.Body>
    </Card>
  )
}
